let language = {
    DETAIL_DESIGN_SELLING: "Start selling with",
    DETAIL_DESIGN_TITLE: "Order a sample",
    DETAIL_DESIGN_TITLE_MOBILE: "Order Sample",    
    DETAIL_INPUT_ERROR_TITLE:"The input is invalid",
    DETAIL_INPUT_ERROR:"The product attributes contain illegal input values. Please make the necessary changes and try again.",
}

export { language }